module.exports = __webpack_public_path__ + "static/01_LA.VIZUAL_JANOWO_PARK_III_v2-f117452842eca61f4da9fea93acb322a.jpg";